import React from 'react';
import { chatStyles } from '../styles/chat.styles';

export const UserIcon = React.memo(() => (
  <div style={chatStyles.messageIcon}>
    <svg 
      width="18" 
      height="18" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor"
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  </div>
));

export const AIIcon = React.memo(({ theme }: { theme: 'light' | 'dark' }) => (
  <div style={chatStyles.messageIcon}>
    <img
      src={theme === 'dark' ? '/logo-only200-removebg-inverted.png' : '/logo-only200-removebg.png'}
      alt="AI"
      style={{
        width: '24px',
        height: '24px',
        objectFit: 'contain'
      }}
    />
  </div>
)); 